<template>
  <div>
    <el-collapse :value="['1']">
      <el-collapse-item title="排序项" name="1">
        <template slot="title">
          排序项
          <span class="stop-blank" @click.stop></span>
          <span class="icon-portal-plus add-item" @click.stop="addSortItem"></span>
        </template>
        <div class="sort-items">
          <div class="sort-item" v-for="(item, index) in sortList" :key="index">
            <span class="sort-title">排序项{{ index + 1 }}</span>
            <el-select placeholder="" @change="selectSortField(index, $event)" :value="item.value" style="width: 132px;">
                <el-option v-for="item in filedMappingList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
            <i class="icon-portal-close delete-icon" @click="deleteItem(index)"></i>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
export default {
  props: {
    myid: {
      type: Object,
      default: () => {},
    },
    options: {
      default: () => {},
      type: Object
    }
  },
  computed: {
    sortList: {
      get() {
        return this.options.sortItems
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "sortItems", false, null, this.ids)
      }
    },
    sortedItemValues() {
      return this.sortList.map(item => item.value)
    },
    ids() {
      return this.$store.state.states.activeID
    },
    noRepeatSelections() {
      return this.filedMappingList.filter(item => !this.sortedItemValues.includes(item.value))
    },
    isListPage() {
      return this.$store.state[this.request_prefix].type === "listPage"
    },
    listPageDataLayoutIds() {
      return this.options.listPageDataLayoutIds
    }
  },
  data() {
    return {
      filedMappingList: [],
      fieldMappingLabelMap: []
    }
  },
  mounted() {
    const dataLayoutIds = this.checkIsInLayoutSide() ? this.ids : this.listPageDataLayoutIds
    if (!dataLayoutIds) return
    const temp = this.shareDataPool.getData(`layoutData-${dataLayoutIds.container_id}-${dataLayoutIds.rect_id}-0`)
    if (!temp || temp.length === 0) return
    const  completeData = JSON.parse(temp)
    const activeIndex = 0
    this.filedMappingList = []
    Object.keys(completeData[activeIndex]).forEach((key, index) => {
      if (key !== "url" && key !== "publicId" && key !== "id" && key !== "pageType" && key !== "viewNum") {
        const temp = {
          value: key,
          label: completeData[activeIndex][key]?.key
        }
        this.filedMappingList.push(temp)
      }
      if (key === "viewNum") {
        const temp = {
          value: key,
          label: "浏览量"
        }
        this.filedMappingList.push(temp)
      }
    })
  },
  methods: {
    addSortItem() {
      this.sortList.push({value: '', label: '', type: 'default'})
    },
    selectSortField(index, item) {
      this.sortList.splice(index, 1, {value: item, label: this.filedMappingList.find(i => i.value === item)?.label, type: 'default'})
    },
    checkIsInLayoutSide() {
      // 判断是不是在自由布局的边栏
      if (typeof this?.ids?.directionIndex !== 'undefined') {
        return true
      } return false
    },
    deleteItem(index) {
      this.sortList.splice(index, 1)
    }
  }
}
</script>
<style lang="scss" scoped>
.add-item {
  font-size: 16px;
  color: rgba(43, 103, 255, 1);
}
.sort-item {
  display: flex;
  align-items: center;
  gap: 8px;
  .sort-title {
    width: 56px;
  }
  .delete-icon {
    display: block;
    width: 24px;
    height: 24px;
    border-radius: 4px;
    font-size: 14px;
    padding: 5px;
    cursor: pointer;
    &:hover {
      background: rgba(0, 0, 0, 0.05);
    }
  }
  &:not(:last-child) {
    margin-bottom: 8px;
  }
}
</style>